import { mdiFileDocument } from "@mdi/js";
import Icon from '@mdi/react';
import { A, HelpPage, Img, Span } from '@reactjscomponentrepository/frontend-components/lib/components';
import guiaimage from "./../assets/guia_ntmppieg.png";
import cem from "./../assets/manual_sim_cem.png";
import LogoSim from "./../images/logotipo_sim_interior.svg";
import reporteInconsistencias from "./../assets/reporte_inconsistencias.png";

export const Learning = () => {

  const breadcrumbs = [
    { path: '/', breadcrumb: 'Inicio' },
    { path: '/learning', breadcrumb: 'Centro de ayuda' }
  ];

  const MANUAL_SIM_CEM = (
    <>
      <h2>Manual de uso y funcionamiento. Módulo CEM</h2>
      <Img alt="Manual" width='300px' src={cem} />
      <p className="mt-2">
        <A href={process.env.PUBLIC_URL + "/docs/manual_sim_cem.pdf"} target="_blank" rel='noreferrer'>Descargar</A>
      </p>
    </>
  );

  const guiaNTMPPIEG = (
    <>
      <h2>Guía para la implementación de la Norma Técnica para la elaboración de Metadatos de los Procesos de Producción de Información Estadística y Geográfica.</h2>
      <div className="w-100 p-2">
          <div className="bg-primary"></div>
          <div className="secondary"></div>
      </div>
      <Img alt="Guia NTMPPIEG" width='300px' src={guiaimage} />
      <p className="mt-2">
        <A href={process.env.PUBLIC_URL + "/docs/guia_para_NTMPPIEG.pdf"} target="_blank" rel='noreferrer'>Descargar</A>
      </p>
    </>
  );
  
  const formatoInconsistencias = (
    <>
      <h2>Formato para el reporte de inconsistencias.</h2>
      <div className="w-100 p-2">
          <div className="bg-primary"></div>
          <div className="secondary"></div>
      </div>
      <Img alt="Formato de inconsistencias" width='300px' src={reporteInconsistencias} />
      <p className="mt-2">
        <A href={process.env.PUBLIC_URL + "/docs/reporte_inconsistencias_SIM.xlsx"} target="_blank" rel='noreferrer'>Descargar</A>
      </p>
    </>
  );

  const topics = [
    {
      title: <><div className='mr-2 text-left' >
        <Span className='flex align-center'><Icon path={mdiFileDocument} size={.8} className='mr-2' /> Manual de uso y funcionamiento. Módulo CEM </Span>
      </div></>, content: MANUAL_SIM_CEM
    },
    {
      title: <><div className='mr-2 text-left' >
        <Span className='flex align-center'><Icon path={mdiFileDocument} size={1.3} className='mr-2' /> Guía para la implementación de la NTMPPIEG (versión: 24-03-2026) </Span>
      </div></>, content: guiaNTMPPIEG
    },
    {
      title: <><div className='mr-2 text-left' >
        <Span className='flex align-center'><Icon path={mdiFileDocument} size={.8} className='mr-2' /> Formato para el reporte de inconsistencias </Span>
      </div></>, content: formatoInconsistencias
    }
  ];

  const footer = (
    <>
      <p className="pt-5">
        Para recibir orientación sobre cualquier duda, aclaración o comentario sobre el acceso o la operación del SIM, contáctenos a través del correo electrónico: 
        <a href="mailto:atención.usuarios@inegi.org.mx"> atención.usuarios@inegi.org.mx</a>
      </p>
    </>
  );

  return (
    <>
      <HelpPage title='Bienvenido al Centro de ayuda' subtitle='SIM' systemLogo={LogoSim} topics={topics}
        customBreadcrumbs={breadcrumbs} showRootBreadcrumb={true} footer={footer} />
    </>
  )
}